module.exports = __webpack_public_path__ + "images/icons_v2/location-map-normal-8d86db3e.svg";